class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Add document-level ESC key listener
    this.handleEscapeKey = (evt) => {
      if (evt.code === "Escape" && this.classList.contains("active")) {
        this.close();
      }
    };
    document.addEventListener("keydown", this.handleEscapeKey);

    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);

    var closeButtons = document.getElementsByClassName("cls-btn");
    var cartSidebar = document.getElementsByClassName("cart-sidebar");

    // Helper function to close sidebar
    const closeSidebar = () => {
      this.close();
    };

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartSidebar = document.querySelector(".cart-sidebar");
      if (cartSidebar) cartSidebar.classList.add("active");
      document
        .querySelector(".fusion-overlay-custom")
        ?.classList.add("overlay-active");
      // Close button functionality
      for (var i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener("click", function (e) {
          e.preventDefault();
          closeSidebar();
        });
      }

      // Click outside sidebar or on overlay to close
      document.addEventListener("click", function (e) {
        var overlay = document.querySelector(".fusion-overlay-custom");
        var isClickInsideSidebar =
          cartSidebar && cartSidebar.contains(e.target);
        var isClickOnOverlay = overlay && overlay.contains(e.target);
        if (!isClickInsideSidebar || isClickOnOverlay) {
          closeSidebar();
        }
      });

      if (typeof window.updateAppliedDiscountCodeUI === "function") {
        window.updateAppliedDiscountCodeUI();
      }
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");

    // Remove cart-sidebar active class
    const cartSidebar = document.querySelector(".cart-sidebar");
    if (cartSidebar) {
      cartSidebar.classList.remove("active");
    }

    // Remove overlay-active class
    const overlay = document.querySelector(".fusion-overlay-custom");
    if (overlay) {
      overlay.classList.remove("overlay-active");
    }

    // Remove z-index class from body
    document.body.classList.remove("z-index");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();

      // Keep cart-sidebar visible
      const cartSidebar = document.querySelector(".cart-sidebar");
      if (cartSidebar) {
        cartSidebar.classList.add("active");
      }

      var closeButtons = document.getElementsByClassName("cls-btn");

      // here the animation doesn't seem to always get triggered. A timeout seem to help

      if (cartSidebar) cartSidebar.classList.add("active");

      // Close button functionality
      for (var i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            this.close();
          }.bind(this),
        );
      }

      if (typeof window.updateAppliedDiscountCodeUI === "function") {
        window.updateAppliedDiscountCodeUI();
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  disconnectedCallback() {
    // Clean up event listener when element is removed
    if (this.handleEscapeKey) {
      document.removeEventListener("keydown", this.handleEscapeKey);
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__contents",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

document.addEventListener("DOMContentLoaded", () => {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("open_cart_drawer") !== "1") return;

    // Clean up the URL so refresh/back doesn't keep forcing it open
    url.searchParams.delete("open_cart_drawer");
    window.history.replaceState(
      {},
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );

    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
    }
  } catch (e) {
    console.error(e);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.updateAppliedDiscountCodeUI === "function") {
    window.updateAppliedDiscountCodeUI();
  }
});
